const imageExtensions = ['JPG', 'JPEG', 'PNG', 'SVG+XML', 'GIF', 'IMAGE'];

const isImage = (type: string) => type?.includes?.('image');

const isVideo = (type: string) => type?.includes?.('video');

const isPdf = (type: string) => type?.includes?.('pdf');

export { imageExtensions, isImage, isVideo, isPdf };
